<div class="rsas_report_popup_parent">
    <div class="rsas_report_popup_wrapper">
        <div class="text_color">You need to change your password to be able to use this website.</div>
        <div class="bottom_btns_wrapper">
            <a href="https://elhusseinyusmleprep.com/log-in/?action=lostpassword"> <button class="btn btn-success pl-3 pr-3 loginpass">Change Password</button> </a>
        </div>
    </div>
</div>